<div class="search-option-wrapper">
  <svg
    class="search-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <use href="#search-icon-paths" />
    </g>
  </svg>
  <span class="search-title">
    Search or Add New Course
  </span>
  <input
    matInput
    [id]="searchInputId"
    class="mat-input-search"
    [placeholder]="MESSAGES?.COURSE_PICKER?.SEARCH_PLACEHOLDER || ''"
    [attr.aria-label]="MESSAGES?.COURSE_PICKER?.SEARCH_LABEL || ''"
    [ngModel]="courseSearchText"
    (ngModelChange)="onSearchInputChange($event)"
    (click)="onStopPropagation($event)"
    (keydown.space)="onKeydownSpace($event)"
    (keydown.enter)="onSearchEnter($event)"
  />
  <small
    class="search-option__status"
    aria-live="polite"
    [class.status-success]="statusMessage === MESSAGES?.COURSE_PICKER?.ADDED_STATUS"
    [class.status-error]="
      statusMessage === MESSAGES?.COURSE_PICKER?.INVALID_FORMAT_STATUS ||
      statusMessage === MESSAGES?.COURSE_PICKER?.EMPTY_NAME_STATUS ||
      statusMessage === MESSAGES?.COURSE_PICKER?.SEARCH_ERROR_STATUS
    "
  >
    {{
      (filteredOptions$ | async)?.length === 0 && !addingCourse
        ? MESSAGES?.COURSE_PICKER?.NO_RESULTS_HELPER || ''
        : statusMessage
    }}
  </small>
  <button
    type="button"
    class="add-course-option-button"
    (click)="onAddCourse($event)"
  >
    + {{ MESSAGES?.COURSE_PICKER?.ADD_NEW_BUTTON || '' }}
  </button>
</div>
